/**
 * What the front desk WRITES about one visit and READS beside it: the
 * reception facts edited in the event panel and in the create dialog
 * (`shared/schedule/ScheduleReceptionFields`), the history of those facts,
 * the panel's conflict evidence and account facts
 * (`shared/schedule/ScheduleReceptionSection`), and the exact reasons a
 * booking was refused. The fact labels themselves — payment, comment, the
 * four marks, the account figures — are `schedule.reception.*`,
 * `schedule.impact.*` and `schedule.finance.*` in the schedule module, because
 * the board's cards read them first; this module adds only the words the
 * editing, the history and the refusal need.
 */
export const scheduleReception = {
  'schedule.receptionEdit.title': 'Reception',
  'schedule.receptionEdit.edit': 'Edit',
  'schedule.receptionEdit.empty': 'Nothing recorded yet',
  'schedule.receptionEdit.markUnset': 'Not stated',
  'schedule.receptionEdit.markYes': 'Yes',
  'schedule.receptionEdit.markNo': 'No',
  'schedule.receptionEdit.stale': 'The visit changed while this was open. Reread it, then save again.',
  'schedule.receptionEdit.reread': 'Reread',
  'schedule.receptionEdit.changed': 'A colleague changed the reception information while this was open. What is shown is what is stored; edit again to change it.',
  'schedule.receptionEdit.withConfirm': 'Recorded together with the confirmation.',
  'schedule.receptionHistory.title': 'History',
  'schedule.receptionHistory.empty': 'No reception changes recorded',
  'schedule.receptionHistory.loading': 'Reading the history',
  'schedule.receptionHistory.loadFailed': 'The history could not be loaded',
  'schedule.receptionHistory.loadMore': 'Load more',
  'schedule.receptionHistory.actor': 'By account',
  'schedule.receptionHistory.changed': 'Changed',
  'schedule.receptionHistory.firstRecord': 'First record',
  'schedule.impactPanel.resources': 'Affected resources',
  'schedule.financeFacts.currency': 'Currency',
  'schedule.refusal.title': 'Why it was refused',
  'schedule.refusal.blocks': 'Blocks the command',
  'schedule.refusal.warning': 'A warning only',
  'schedule.refusal.resource': 'Resource',
  'schedule.refusal.requirement': 'Requirement',
  'schedule.refusal.when': 'When',
  'schedule.refusal.existingEvent': 'Conflicting event',
  'schedule.refusal.existingReservation': 'Conflicting reservation',
  'schedule.refusal.field': 'Field',
} as const
